// Test Ids
export const testIds = {
	NO_MATCHING_RESULTS: 'tid-no-matching-results',
	TERM_DEF_PRONUNCIATION: 'tid-term-def-pronunciation',
	TERM_ITEM_PRONUNCIATION: 'tid-term-item-pronunciation',
	SEARCH_PAGE_UNIT: 'tid-search-page-unit',
	RESULTS_PAGER_TOP: 'tid-results-pager-top',
	RESULTS_PAGER_BOTTOM: 'tid-results-pager-bottom',
};
